import { render, staticRenderFns } from "./addcommercial_pzxx1.vue?vue&type=template&id=ff9bf288&scoped=true&"
import script from "./addcommercial_pzxx1.vue?vue&type=script&lang=js&"
export * from "./addcommercial_pzxx1.vue?vue&type=script&lang=js&"
import style0 from "./addcommercial_pzxx1.vue?vue&type=style&index=0&id=ff9bf288&scoped=true&lang=css&"
import style1 from "./addcommercial_pzxx1.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff9bf288",
  null
  
)

export default component.exports